export const tourInstallmentsApiQueryKeys = {
  all: () => ['installments'] as const,
  byTour: (tourId: string) => ['installments', tourId] as const,
};
